
var ListViewRequest = function () {
    this.ValueSet = {};
    this.ValueSet2 = {};
    this.ValueSet3 = {};
    this.ValueSet4 = {};
    this.AttributeSet = {};
    this.AttributeSet2 = {};
    this.AttributeSet3 = {};
    this.AttributeSet4 = {};
    this.FirstQuery = true;
    this.Query = {

    };
    this.OrderBy = "";
    this.Paging = {
        TotalCount: 0,
        RecordPerPage: 10,
        CurrentPageNumber: 1
    };

    this.Bag = {};
    this.Rows = [];
    this.SelectedRows = [];
    this.SelectedRowsFromRequest = [];
}


export default ListViewRequest
